import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  EnterpriseConfigurationDataAccessService,
  IEnterpriseConfiguration,
} from './enterprise-configuration-data-access.service';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseConfigurationResolver {
  constructor(private _enterpriseConfigurationService: EnterpriseConfigurationDataAccessService) {}

  public resolve(): Observable<IEnterpriseConfiguration> {
    return this._enterpriseConfigurationService.getEnterpriseConfiguration();
  }
}
